import { Box } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import { primitive } from 'styles/constants';
import { isNative } from 'utils/environment';

export const StyledButtonWidthLimit = Box.withConfig({
  width: {
    md: '335px',
  },
  marginX: {
    md: 'auto',
  },
  _web: {
    width: 'full',
  },
});

export const TextInputWrapper = Box.withConfig({
  paddingX: '1',
  width: 'full',
});

export const LabelStyled = withTypography({
  color: primitive.$bbqBrown,
  bold: isNative,
  style: { fontWeight: isNative ? undefined : 'normal', alignSelf: 'center' },
});
